import { ReactComponent as InfoIcon } from 'libs/shared/assets/src/lib/icons/info.svg'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
    display: flex;
    gap: 1rem;
    margin: 0.5rem 0 1.5rem 0;
    align-items: center;
`

const StyledInfoIcon = styled(InfoIcon)`
    width: 3.8rem;
`

export const Title = styled.h4(({
  theme: {
    palette,
    typography,
  },
}) => css`
    font-weight: 500;
    font-size: ${typography.main.pt_15_semibold.fontSize};
    line-height: ${typography.main.pt_15_semibold.lineHeight};
    letter-spacing: ${typography.main.pt_15_semibold.letterSpacing};
    color: ${palette.results.red.dark};
  `)

export const WarningInfoSection: React.FC<{warningInfo?: string}> = ({ warningInfo }) => {
  const { t } = useTranslation()

  const warningInfoTranslation = useMemo(() => {
    switch (warningInfo) {
      case 'road-simulation':
        return t('placeme.mcd_potential_tile.warning_info.road_simulation')
      case 'outside_of_boundary_conditions':
        return t('placeme.mcd_potential_tile.warning_info.outside-boundary-conditions')
      default:
        return t('placeme.mcd_potential_tile.warning_info.outside-boundary-conditions')
    }
  }, [warningInfo, t])

  if (!warningInfo) return null

  return (
    <Wrapper>
      <StyledInfoIcon />
      <Title>
        {warningInfoTranslation}
      </Title>
    </Wrapper>
  )
}
